document.addEventListener("DOMContentLoaded", () => {

  if (!customElements.get('custom-product-module')) {
    customElements.define(
      'custom-product-module',
      class extends HTMLElement {
        constructor() {
          super();
          this.mainSwiper = null;
          this.thumbSwiper = null;
          this.testiSwipers = [];
          this.abortController = null;
        }

        connectedCallback() {
          this.loadSwiperScript().then(() => {
            this.initGallery();
            this.initTestimonials();
            this.initQtyLogic(); // 🌟 初始化数量盒子逻辑
          });
          this.addEventListener('change', this.handleOptionChange.bind(this));
        }

        disconnectedCallback() {
          if (this.mainSwiper) this.mainSwiper.destroy();
          if (this.thumbSwiper) this.thumbSwiper.destroy();
          this.testiSwipers.forEach((s) => s.destroy());
          if (this.abortController) this.abortController.abort();
        }

        // --- 数量控制逻辑 (支持不可减少时的灰色状态) ---
        initQtyLogic() {
          const qtyBoxes = this.querySelectorAll('.js-qty-box');
          qtyBoxes.forEach(box => {
            const minusBtn = box.querySelector('.js-qty-minus');
            const plusBtn = box.querySelector('.js-qty-plus');
            const input = box.querySelector('.js-qty-input');

            const updateState = () => {
              const currentVal = parseInt(input.value) || 1;
              const minVal = parseInt(input.getAttribute('min')) || 1;
              if (currentVal <= minVal) {
                minusBtn.classList.add('is-disabled');
              } else {
                minusBtn.classList.remove('is-disabled');
              }
            };

            minusBtn.addEventListener('click', () => {
              if (minusBtn.classList.contains('is-disabled')) return;
              input.stepDown();
              updateState();
            });

            plusBtn.addEventListener('click', () => {
              input.stepUp();
              updateState();
            });

            input.addEventListener('change', updateState);
            updateState(); // 初始化检测
          });
        }

        get submitButton() {
          return this.querySelector('.js-add-btn');
        }
        get submitButtonText() {
          return this.querySelector('.js-btn-text');
        }
        get dynamicButtonWrap() {
          return this.querySelector('.js-dynamic-btn-wrap');
        }
        
        toggleSubmitButton(disable = true, text) {
          if(!this.submitButton) return;
          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            if (text && this.submitButtonText) this.submitButtonText.textContent = text;
            const icon = this.submitButton.querySelector('.js-btn-icon');
            if(icon) icon.style.display = 'none';
          } else {
            this.submitButton.removeAttribute('disabled');
            if(this.submitButtonText) {
              this.submitButtonText.textContent = window.variantStrings ? window.variantStrings.addToCart : this.submitButton.getAttribute('data-available-text');
            }
            const icon = this.submitButton.querySelector('.js-btn-icon');
            if(icon) icon.style.display = 'block';
          }
        }

        setLoading(isLoading) {
          if (isLoading) {
            if (this.submitButton) this.submitButton.classList.add('cpm-loading-overlay');
            if (this.dynamicButtonWrap) {
              const shopifyBtn = this.dynamicButtonWrap.querySelector('.shopify-payment-button');
              if (shopifyBtn) shopifyBtn.classList.add('cpm-loading-overlay');
            }
          } else {
            if (this.submitButton) this.submitButton.classList.remove('cpm-loading-overlay');
            if (this.dynamicButtonWrap) {
              const shopifyBtn = this.dynamicButtonWrap.querySelector('.shopify-payment-button');
              if (shopifyBtn) shopifyBtn.classList.remove('cpm-loading-overlay');
            }
          }
        }

        loadSwiperScript() {
          return new Promise((resolve) => {
            if (typeof window.Swiper !== 'undefined') return resolve();
            if (!document.querySelector('link[href*="swiper-bundle.min.css"]')) {
              const link = document.createElement('link');
              link.rel = 'stylesheet';
              link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
              document.head.appendChild(link);
            }
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
            script.onload = resolve;
            document.head.appendChild(script);
          });
        }

        initTestimonials() {
          const testiContainers = this.querySelectorAll('.js-testi-swiper');
          testiContainers.forEach((container) => {
            const count = parseInt(container.getAttribute('data-count')) || 1;
            if (count > 1) {
              const swiper = new Swiper(container, {
                loop: true,
                autoplay: { delay: 3500, disableOnInteraction: false },
                slidesPerView: 1,
                spaceBetween: 10,
              });
              this.testiSwipers.push(swiper);
            }
          });
        }

        initGallery() {
          const thumbContainer = this.querySelector('.js-thumb-swiper');
          const mainContainer = this.querySelector('.js-main-swiper');
          if (!thumbContainer || !mainContainer) return;

          const thumbCount = parseInt(this.getAttribute('data-thumb-count')) || 4;
          let initialIndex = parseInt(this.getAttribute('data-initial-slide')) || 0;

          const urlParams = new URLSearchParams(window.location.search);
          const variantId = urlParams.get('variant');
          if (variantId) {
            const variantsJsonEl = this.querySelector('.js-variants-json');
            if (variantsJsonEl) {
              try {
                const variantsData = JSON.parse(variantsJsonEl.textContent);
                const matchedVariant = variantsData.find((v) => String(v.id) === variantId);
                if (matchedVariant && matchedVariant.featured_image && matchedVariant.featured_image.position) {
                  initialIndex = matchedVariant.featured_image.position - 1;
                }
              } catch (e) {}
            }
          }

          this.thumbSwiper = new Swiper(thumbContainer, {
            initialSlide: initialIndex,
            spaceBetween: 5,
            slidesPerView: thumbCount,
            freeMode: true,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
          });

          this.mainSwiper = new Swiper(mainContainer, {
            initialSlide: initialIndex,
            spaceBetween: 10,
            navigation: {
              nextEl: '.js-swiper-next',
              prevEl: '.js-swiper-prev',
            },
            // pagination: {
            //   el: '.swiper-pagination',
            //   clickable: true,
            // },
            thumbs: {
              swiper: this.thumbSwiper,
              autoScrollOffset: 1,
            },
          });

          setTimeout(() => {
            if (initialIndex > 0) {
              if (this.mainSwiper) this.mainSwiper.slideTo(initialIndex, 0);
              if (this.thumbSwiper) this.thumbSwiper.slideTo(initialIndex, 0);
            }
          }, 50);
        }

        handleOptionChange(e) {
          if (!e.target.classList.contains('cpm-opt-radio')) return;

          const group = e.target.closest('.js-opt-group');
          group.querySelectorAll('.cpm-opt-pill').forEach((pill) => pill.classList.remove('is-active'));
          e.target.closest('.cpm-opt-pill').classList.add('is-active');

          const variantsJsonEl = this.querySelector('.js-variants-json');
          if (!variantsJsonEl) return;
          let variantsData = [];
          try {
            variantsData = JSON.parse(variantsJsonEl.textContent);
          } catch (err) {
            return;
          }

          const selectedOptions = Array.from(this.querySelectorAll('.cpm-opt-radio:checked')).map((r) => r.value);
          const matchedVariant = variantsData.find((v) =>
            selectedOptions.every((val, idx) => v.options[idx] === val)
          );

          if (matchedVariant) {
            this.setLoading(true);
            if (this.abortController) this.abortController.abort();
            this.abortController = new AbortController();

            window.history.replaceState({}, '', `${window.location.pathname}?variant=${matchedVariant.id}`);

            if (matchedVariant.featured_image && matchedVariant.featured_image.position) {
              const targetIndex = matchedVariant.featured_image.position - 1;
              if (this.mainSwiper) this.mainSwiper.slideTo(targetIndex);
              if (this.thumbSwiper) this.thumbSwiper.slideTo(targetIndex);
            }

            const sectionId = this.getAttribute('data-section-id');
            const fetchUrl = `${window.location.pathname}?variant=${matchedVariant.id}&section_id=${sectionId}`;

            fetch(fetchUrl, { signal: this.abortController.signal })
              .then((res) => res.text())
              .then((text) => {
                const html = new DOMParser().parseFromString(text, 'text/html');

                const newPrice = html.querySelector('.js-price-block');
                const oldPrice = this.querySelector('.js-price-block');
                const oldRatio = this.querySelector('.cpm-price-badge');
                const newRatio = html.querySelector('.cpm-price-badge');

                if (newPrice && oldPrice) oldPrice.innerHTML = newPrice.innerHTML;
                if (oldRatio && newRatio) oldRatio.innerHTML = newRatio.innerHTML;

                const newOptionsList = html.querySelectorAll('.cpm-opt-pill');
                const oldOptionsList = this.querySelectorAll('.cpm-opt-pill');
                if (newOptionsList.length === oldOptionsList.length) {
                  newOptionsList.forEach((newPill, index) => {
                    const oldPill = oldOptionsList[index];
                    if (newPill.classList.contains('is-unavailable')) {
                      oldPill.classList.add('is-unavailable');
                    } else {
                      oldPill.classList.remove('is-unavailable');
                    }
                  });
                }

                this.setLoading(false);

                if (!matchedVariant.available) {
                  const soldOutText = window.variantStrings ? window.variantStrings.soldOut : 'Sold Out';
                  this.toggleSubmitButton(true, soldOutText);
                } else {
                  this.toggleSubmitButton(false);
                }

                const variantInput = this.querySelector('.js-variant-id');
                if (variantInput) {
                  variantInput.value = matchedVariant.id;
                  variantInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
              })
              .catch((err) => {
                if (err.name !== 'AbortError') {
                  console.error('Failed to update section:', err);
                  this.setLoading(false);
                }
              });
          } else {
            const unavailableText = window.variantStrings ? window.variantStrings.unavailable : 'Unavailable';
            this.toggleSubmitButton(true, unavailableText);
            this.setLoading(false);
          }
        }
      }
    );
  }

})